/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M6 17H9.24853C7.31896 16.0319 6 14.0772 6 11.8235C6 8.60728 8.68629 6 12 6C15.3137 6 18 8.60728 18 11.8235C18 14.0772 16.681 16.0319 14.7515 17H18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M6 17H9.24853C7.31896 16.0319 6 14.0772 6 11.8235C6 8.60728 8.68629 6 12 6C15.3137 6 18 8.60728 18 11.8235C18 14.0772 16.681 16.0319 14.7515 17H18M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM6.75 11.8235C6.75 9.04244 9.07924 6.75 12 6.75C14.9208 6.75 17.25 9.04244 17.25 11.8235C17.25 13.774 16.109 15.4798 14.4151 16.3296C14.1044 16.4855 13.9415 16.8345 14.0217 17.1728C14.1018 17.5111 14.4038 17.75 14.7515 17.75H18C18.4142 17.75 18.75 17.4142 18.75 17C18.75 16.5858 18.4142 16.25 18 16.25H16.9901C18.0808 15.0846 18.75 13.533 18.75 11.8235C18.75 8.17212 15.7067 5.25 12 5.25C8.29334 5.25 5.25 8.17212 5.25 11.8235C5.25 13.533 5.91917 15.0846 7.00987 16.25H6C5.58579 16.25 5.25 16.5858 5.25 17C5.25 17.4142 5.58579 17.75 6 17.75H9.24853C9.59617 17.75 9.89824 17.5111 9.97835 17.1728C10.0585 16.8345 9.8956 16.4855 9.58488 16.3296C7.89101 15.4798 6.75 13.774 6.75 11.8235Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M6 17H9.24853C7.31896 16.0319 6 14.0772 6 11.8235C6 8.60728 8.68629 6 12 6C15.3137 6 18 8.60728 18 11.8235C18 14.0772 16.681 16.0319 14.7515 17H18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M6 17H9.24853C7.31896 16.0319 6 14.0772 6 11.8235C6 8.60728 8.68629 6 12 6C15.3137 6 18 8.60728 18 11.8235C18 14.0772 16.681 16.0319 14.7515 17H18M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 6.75C9.07924 6.75 6.75 9.04244 6.75 11.8235C6.75 13.774 7.89101 15.4798 9.58488 16.3296C9.8956 16.4855 10.0585 16.8345 9.97835 17.1728C9.89824 17.5111 9.59617 17.75 9.24853 17.75H6C5.58579 17.75 5.25 17.4142 5.25 17C5.25 16.5858 5.58579 16.25 6 16.25H7.00987C5.91917 15.0846 5.25 13.533 5.25 11.8235C5.25 8.17212 8.29334 5.25 12 5.25C15.7067 5.25 18.75 8.17212 18.75 11.8235C18.75 13.533 18.0808 15.0846 16.9901 16.25H18C18.4142 16.25 18.75 16.5858 18.75 17C18.75 17.4142 18.4142 17.75 18 17.75H14.7515C14.4038 17.75 14.1018 17.5111 14.0217 17.1728C13.9415 16.8345 14.1044 16.4855 14.4151 16.3296C16.109 15.4798 17.25 13.774 17.25 11.8235C17.25 9.04244 14.9208 6.75 12 6.75Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
